import React, { ReactNode } from 'react'

import { Editor } from 'slate'
import { useSlate } from 'slate-react'

import { Toolbar } from '@app/lib/inputs/RichEditor/editor/Toolbar'
import { LeafMark } from '@app/lib/inputs/RichEditor/types'

export type MarkButtonProps = {
  format: LeafMark
  icon: ReactNode
  'aria-label': string
}

export const MarkButton = ({ format, icon, 'aria-label': ariaLabel }: MarkButtonProps) => {
  const editor = useSlate()
  return (
    <Toolbar.Button
      aria-label={ariaLabel}
      active={isMarkActive(editor, format)}
      onMouseDown={(event) => {
        event.preventDefault()
        toggleMark(editor, format)
      }}
      icon={icon}
    />
  )
}

const toggleMark = (editor: Editor, format: string) => {
  const isActive = isMarkActive(editor, format)

  if (isActive) {
    Editor.removeMark(editor, format)
  } else {
    Editor.addMark(editor, format, true)
  }
}

const isMarkActive = (editor: Editor, format: string) => {
  const marks = Editor.marks(editor)
  return marks ? marks[format] === true : false
}
